import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
// Cambiamos el import a 'react-router' y removemos createRoutesFromElements y Route
import { createBrowserRouter, RouterProvider } from "react-router";
import Answer from './components/Answer';
import Body from './components/Body';
import View from './components/View';
import Layout from './Layout';
import NotFound from './components/NotFound';
import Vinculos from './components/Vinculos';
import AdminSecciones from './components/AdminSecciones';
import SoporteGuard from './components/SoporteGuard';
import 'jquery';

// Definición de rutas limpia usando objetos (Formato nativo de React Router v7)
const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Body /> },
      { path: "home", element: <Body /> },
      { path: "home/:hash", element: <Body /> },
      { path: "home/:hash/link/:link", element: <Body /> },
      { path: "buscador/:termino", element: <Answer /> },
      { path: "link/:id", element: <View /> },
      {
        path: "vinculos/:id",
        element: <SoporteGuard><Vinculos /></SoporteGuard>
      },
      {
        path: "vinculos/:id/:seccion",
        element: <SoporteGuard><Vinculos /></SoporteGuard>
      },
      {
        path: "admin/secciones",
        element: <SoporteGuard><AdminSecciones /></SoporteGuard>
      },
      // { 
      //   path: "admin/vinculos/:id", 
      //   element: <SoporteGuard><AdminVinculos /></SoporteGuard> 
      // },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();